
import { defineComponent, PropType } from 'vue'
import { Game } from '@/types/game'

export default defineComponent({
  name: 'GameStartModal',
  props: {
    game: {
      type: Object as PropType<Game>,
      required: true
    }
  },
  setup(props, context) {
    const onClickStartButton = (status: number, type: 'start' | 'end' | 'pk') => {
      context.emit('onClickStartButton', status, type)
    }

    return {
      onClickStartButton
    }
  }
})
